"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n\t\tstroke-dasharray: ", ";\n\t"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n\tstroke: ", ";\n\tstroke-dashoffset: 0;\n\tanimation: ", " 1.5s ease-in-out infinite, color 6s ease-in-out infinite;\n\tstroke-linecap: round;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tanimation: ", " 2s linear infinite;\n\theight: 100%;\n\ttransform-origin: center center;\n\twidth: 100%;\n\ttop: 0;\n\tbottom: 0;\n\tleft: 0;\n\tright: 0;\n\tmargin: auto;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\tpadding: ", ";\n\twidth: 100px;\n\theight: 100px;\n\tbackground: ", ";\n\tborder-radius: 50%;\n\tbox-shadow: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n{\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0;\n    stroke: ", ";\n  }\n  50% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -35px;\n    stroke: ", ";\n  }\n  100% {\n    stroke-dasharray: 89, 200;\n    stroke-dashoffset: -124px;\n    stroke: ", ";\n  }\n}\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  100% {\n    transform: rotate(360deg);\n  }\n}"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\theight: 100vh;\n\twidth: 100%;\n\tz-index: 9998;\n\tbackground: rgba(0, 0, 0, 0.3);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Background = _styledComponents.default.div(_templateObject());

Background.displayName = 'Background';
var Rotate = (0, _styledComponents.keyframes)(_templateObject2());
var Dash = (0, _styledComponents.keyframes)(_templateObject3(), _colors.default.primary, _colors.default.secondary, _colors.default.primary);

var Loader = _styledComponents.default.div(_templateObject4(), _spacing.default.s1, _colors.default.white, _vars.default.boxShadow);

Loader.displayName = 'Loader';

var Circular = _styledComponents.default.svg(_templateObject5(), Rotate);

Circular.displayName = 'Circular';

var Circle = _styledComponents.default.circle(_templateObject6(), _colors.default.primary, Dash);

Circle.displayName = 'Circle';

var PageLoader = function PageLoader(_ref) {
  var isLoading = _ref.isLoading,
      rest = _objectWithoutPropertiesLoose(_ref, ["isLoading"]);

  var isIE11 = window.navigator.userAgent.indexOf('Trident/7') > -1;
  var PolyfilledCircle = (0, _styledComponents.default)(Circle)(_templateObject7(), isIE11 ? '100' : '1, 200');
  PolyfilledCircle.displayName = 'PolyfilledCircle';

  if (!isLoading) {
    return null;
  }

  return _react.default.createElement(Background, rest, _react.default.createElement(Loader, null, _react.default.createElement(Circular, {
    viewBox: "25 25 50 50"
  }, _react.default.createElement(PolyfilledCircle, {
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none",
    strokeWidth: "5",
    strokeMiterlimit: "10"
  }))));
};

PageLoader.displayName = 'PageLoader';
PageLoader.propTypes = {
  isLoading: _propTypes.bool.isRequired
};
var _default = PageLoader;
exports.default = _default;